import React, { FC, useEffect, useState } from "react";
import CustomTable from "../../../components/Tables/CustomTable";
import DropdownMenu from "../../ui/DropdownMenu";
import { MoreVertical } from "lucide-react";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { fetchAllCoupons } from "../../../redux/features/CouponSlice";
import AssignCouponModal from "./modals/AssignCouponModal";

interface UsedCouponsTableProps {
  page: number;
  limit: number;
  setPage: (value: number) => void;
  setLimit: (value: number) => void;
  selectedCoupon: any;
  setSelectedCoupon: (value: any) => void;
  setEditModalOpen: (value: boolean) => void;
  setDeleteModalOpen: (value: boolean) => void;
}

const CouponsTable: FC<UsedCouponsTableProps> = ({
  page,
  limit,
  setPage,
  setLimit,
  setSelectedCoupon,
  setEditModalOpen,
  setDeleteModalOpen,
  selectedCoupon,
}) => {
  const dispatch = useAppDispatch();
  const [openAssignUser, setOpenAssignUser] = useState(false);
  const { coupons, loading } = useAppSelector((state) => state.coupons);

  const dropdownOptionsForCoupon = [
    {
      label: "Assign User",
      onClick: (coupon: any) => {
        setSelectedCoupon(coupon);
        setOpenAssignUser(true);
      },
      returnAll: true,
    },
    // {
    //   label: "Edit",
    //   onClick: (coupon: any) => {
    //     setSelectedCoupon(coupon);
    //     setEditModalOpen(true);
    //   },
    //   returnAll: true,
    // },
    // {
    //   label: <span className="text-red-500">Delete</span>,
    //   onClick: (coupon: any) => {
    //     setSelectedCoupon(coupon);
    //     setDeleteModalOpen(true);
    //   },
    //   returnAll: true,
    // },
  ];

  const couponData = {
    columns: [
      { label: "Code", field: "code" },
      { label: "Coupon Type", field: "type" },
      { label: "Value", field: "value" },
      { label: "Expires", field: "expiryDate" },
      { label: "Status", field: "status" },
      { label: "Action", field: "action" },
    ],
    rows: coupons?.data?.items?.map((item: any, index: number) => {
      const isExpired = new Date(item?.expiryDate) < new Date();
      const value =
        item?.couponAmount !== null
          ? `₦${item?.couponAmount}`
          : item?.couponDiscount !== null
          ? `${item?.couponDiscount}%`
          : "N/A";

      return {
        id: index + 1,
        code: item?.couponCode,
        type: item?.couponType,
        value,
        expiryDate: moment(item?.expiryDate).format("Do MMM YYYY"),
        status: (
          <span
            className={`text-xs font-semibold px-3 py-1 rounded-full ${
              isExpired
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {isExpired ? "Expired" : "Active"}
          </span>
        ),
        action: (
          <DropdownMenu
            options={dropdownOptionsForCoupon}
            icon={<MoreVertical style={{ cursor: "pointer" }} />}
            item={item}
          />
        ),
      };
    }),
  };

  useEffect(() => {
    dispatch(fetchAllCoupons({ page: page + 1, limit }));
  }, [dispatch, page, limit]);


  return (
    <>
      <CustomTable
        data={couponData}
        noRecordText="No Coupons Available"
        loading={loading}
        showFooter={true}
        totalPages={coupons?.meta?.totalPages}
        itemsPerPage={coupons?.meta?.itemsPerPage}
        currentPage={page}
        onPageChange={(value: number) => setPage(value)}
        onLimitChange={(value: number) => {
          setLimit(value);
          setPage(0);
        }}
      />

      <AssignCouponModal
        open={openAssignUser}
        onClose={() => setOpenAssignUser(false)}
        onSave={() => setOpenAssignUser(false)}
        selectedCoupon={selectedCoupon}
      />
    </>
  );
};

export default CouponsTable;
